import { useEffect } from "react";

import authService from "../../services/authService";

import FullscreenLoadingOverlay from "../../components/FullscreenLoadingOverlay";

function LogoutUI() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("security-check", { detail: true }));
    setTimeout(() => {
      authService.logout();
    }, 1500);
  }, []);

  return <FullscreenLoadingOverlay message="Logging out..." />;
}

export default LogoutUI;
